
import MenuUploadAddonsBulkUpload from "./menu-upload-addons-bulk-upload.vue";
import MenuUploadImageBulkUpload from "./menu-upload-image-bulk-upload.vue";

export default {
  components: {
    MenuUploadImageBulkUpload,
    MenuUploadAddonsBulkUpload
  },
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },

  methods: {}
};
